import { sectionRenderer } from '@theme/section-renderer';
import { RecentlyViewed } from '@theme/recently-viewed-products';

/**
 * @param {HTMLElement | null | undefined} container
 */
export async function hydrateFacetsCatalogRecentlyViewed(container) {
  if (!container || container.dataset.hydrated === 'true') return;

  const sectionId = container.dataset.sectionId || 'predictive-search';
  const ids = RecentlyViewed.getProducts();
  if (ids.length === 0) {
    container.hidden = true;
    return;
  }

  const searchPath =
    container.dataset.searchUrl ||
    /** @type {any} */ (typeof Theme !== 'undefined' ? Theme : globalThis.Theme)?.routes?.search_url;
  if (!searchPath) return;

  const url = new URL(searchPath, window.location.origin);
  url.searchParams.set('q', ids.map((/** @type {string} */ id) => `id:${id}`).join(' OR '));
  url.searchParams.set('resources[type]', 'product');

  let markup = '';
  try {
    markup = await sectionRenderer.getSectionHTML(sectionId, false, url);
  } catch {
    return;
  }

  const doc = new DOMParser().parseFromString(markup, 'text/html');
  const productsRoot = doc.getElementById('predictive-search-products');
  if (!productsRoot) return;

  const headingText = container.dataset.recentTitle || '';
  const wrapper = document.createElement('div');
  wrapper.className = 'facets-catalog__recent-inner';

  if (headingText) {
    const h = document.createElement('p');
    h.className = 'facets-catalog__recent-heading';
    h.textContent = headingText;
    wrapper.appendChild(h);
  }

  const list = productsRoot.querySelector('.predictive-search-results__wrapper-products, .recently-viewed-wrapper');
  if (list) {
    const clone = /** @type {HTMLElement} */ (list.cloneNode(true));
    clone.classList.add('facets-catalog__recent-list');
    wrapper.appendChild(clone);
  } else {
    wrapper.innerHTML = productsRoot.innerHTML;
  }

  container.appendChild(wrapper);
  container.dataset.hydrated = 'true';
}

function init() {
  document.querySelectorAll('[data-facets-catalog-recently-viewed]').forEach((el) => {
    if (!(el instanceof HTMLElement)) return;
    const inDrawer = el.closest('#filters-drawer');
    if (!inDrawer) {
      void hydrateFacetsCatalogRecentlyViewed(el);
    }
  });

  const drawer = document.querySelector('#filters-drawer');
  if (drawer) {
    drawer.addEventListener('dialog:open', () => {
      const el = drawer.querySelector('[data-facets-catalog-recently-viewed]');
      void hydrateFacetsCatalogRecentlyViewed(el instanceof HTMLElement ? el : null);
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
